var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('banner-modulos'),_c('all-modules'),_c('div',{staticClass:"todosModulos"},_vm._l((_vm.getModulos),function(modulo){return _c('modules',{key:modulo.nr_sequencial,attrs:{"modulo":modulo}})}),1),_c('rodape')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }